import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { User } from '../../../classes/user';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../../../services/user';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  user!: User;

  constructor(private route: ActivatedRoute,
              private userService: UserService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.userService.getByID(params.get('id'))
        .subscribe({
          next: (user: any) => {
            this.user = user;
            console.log(this.user);
          },
          error: (err: HttpErrorResponse) => {
            console.log(err);
          }
        });
    });
  }

}
